import React from 'react';

const HoverLogoWhite = ({ ...props }) => (
  <svg
    width="147"
    height="36"
    viewBox="0 0 147 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M54.3862 19.1668H43.8167V11.0762H41.2188V29.8622H43.8167V21.6466H54.3862V29.8622H56.9842V11.0762H54.3862V19.1668Z"
      fill="white"
    />
    <path
      d="M73.3952 10.8203C67.7783 10.8203 63.707 14.8788 63.707 20.4764C63.707 26.0741 67.7849 30.126 73.3952 30.126C79.0055 30.126 83.0833 26.0675 83.0833 20.4764C83.0833 14.8854 79.012 10.8203 73.3952 10.8203ZM78.3872 25.64C77.1178 26.9095 75.342 27.6067 73.3952 27.6067C71.4483 27.6067 69.6856 26.9095 68.4097 25.64C67.114 24.3441 66.4037 22.509 66.4037 20.4764C66.4037 18.4439 67.114 16.6021 68.4097 15.3129C69.6791 14.0434 71.4483 13.3462 73.3952 13.3462C75.342 13.3462 77.1178 14.0434 78.3872 15.3129C79.6829 16.6021 80.3998 18.4373 80.3998 20.4764C80.3998 22.5155 79.6829 24.3441 78.3872 25.64Z"
      fill="white"
    />
    <path
      d="M96.0787 26.9022L89.2384 11.0762H86.4629L94.533 29.7109L94.5922 29.8622H97.5191L105.635 11.0762H102.932L96.0787 26.9022Z"
      fill="white"
    />
    <path
      d="M113.507 21.6334H123.169V19.1799H113.507V13.5428H124.899V11.0762H110.916V29.8622H125.011V27.3955H113.507V21.6334Z"
      fill="white"
    />
    <path
      d="M141.12 21.8176C143.474 21.4558 145.882 19.9101 145.882 16.4831C145.882 14.7597 145.296 13.4113 144.139 12.4707C142.994 11.5432 141.35 11.0762 139.245 11.0762H131.826V29.8622H134.424V21.9031H138.219L143.875 29.8622H147L141.12 21.8176ZM134.424 19.5023V13.5428H139.219C141.863 13.5428 143.205 14.5295 143.205 16.4831C143.205 18.4893 141.863 19.5023 139.219 19.5023H134.424Z"
      fill="white"
    />
    <path
      d="M0 16.0039V30.8959L9.76047 26.0021V11.1035L0 16.0039Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.515 21.1014L31.709 14.9775L17.0749 0L4.88086 6.12388L19.515 21.1014ZM19.5156 36.001V21.1024L31.7096 14.9785V29.8771L19.5156 36.001Z"
      fill="white"
    />
    <path
      d="M14.6354 34.724L9.76172 33.448V26.002L14.6354 27.2715V34.724Z"
      fill="white"
    />
    <path
      d="M0 16.0039V30.8959L9.76047 26.0021V11.1035L0 16.0039Z"
      fill="white"
    />
    <path
      d="M31.709 14.9775L19.515 21.1014L4.88086 6.12388L17.0749 0L31.709 14.9775Z"
      fill="white"
    />
    <path
      d="M14.6354 34.724L9.76172 33.448V26.002L14.6354 27.2715V34.724Z"
      fill="white"
    />
  </svg>
);

export default HoverLogoWhite;
